export default {
    indexAllocations:        { method: 'get',     url: 'allocations' },
    allocationCreate:        { method: 'post',    url: 'allocations' },
    allocationUpdate:        { method: 'put',     url: 'allocations/{id}' },
    allocationDelete:        { method: 'delete',  url: 'allocations/{id}' },
    indexAllocationsAll:     { method: 'get',     url: 'allocations/{ambience_id}/all' },
}